export const contractReportTypes = {
    REPORT_ROAD_SAFETY: 1,
    REPORT_WORK_DIARY: 2,
    REPORT_EQUIPMENT_INSPECTION: 3,
    REPORT_ROAD_INSPECTION: 4,
    REPORT_MATERIAL: 5
}

export const contractClassTypes = {
    COST: 1,
    INVESTMENT: 2
}

export const contractHelper = {
    methods: {
        getUniqueId: function () {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                const r = Math.random() * 16 | 0
                const v = c === 'x' ? r : (r & 0x3 | 0x8)
                return v.toString(16)
            })
        },
        setContractCollections(contracts) {
            // Initialize a Map to keep track of unique ids
            const uniqueIds = new Map();
            this.contractCollectionOptions = []

            if (contracts && contracts.length > 0) {
                contracts.forEach(contract => {
                    if (contract && contract.contract_collection && contract.contract_collection.id) {
                        // Check if id is already present
                        if (!uniqueIds.has(contract.contract_collection.id)) {
                            uniqueIds.set(contract.contract_collection.id, true); // Mark this id as encountered
                            this.contractCollectionOptions.push(contract.contract_collection);
                        }
                    }
                });
            }
        },
        getContractClassType(type) {
            switch (type) {
                case contractClassTypes.COST: return this.$t('contracts.contract_class.type.cost')
                case contractClassTypes.INVESTMENT:  return this.$t('contracts.contract_class.type.investment')
            }
            return this.$t('inspectable.types.none')
        },
        filterContracts: function () {
            // If both selectedCompany and contractCollection are defined
            if (this.selectedCompany && this.contractCollection && this.contractCollection.id) {
                this.filteredContracts = this.contracts.filter(item =>
                    item.customer.id === this.selectedCompany &&
                    item.contract_collection &&
                    item.contract_collection.id === this.contractCollection.id
                );
                // If only selectedCompany is defined
            } else if (this.selectedCompany) {
                this.filteredContracts = this.contracts.filter(item =>
                    item.customer.id === this.selectedCompany
                );
                // If only contractCollection is defined
            } else if (this.contractCollection && this.contractCollection.id) {
                this.filteredContracts = this.contracts.filter(item =>
                    item.contract_collection &&
                    item.contract_collection.id === this.contractCollection.id
                );
            } else {
                // If neither selectedCompany nor contractCollection is defined, include all contracts
                this.filteredContracts = this.contracts;
            }

            // Filter by storage contract IDs if provided
            if (this.storageContractIds) {
                this.filteredContracts = this.filteredContracts.filter(c => this.storageContractIds.includes(c.id))
                if (this.selectedContract && !this.filteredContracts.find(c => c.id === this.selectedContract.id)) {
                    this.selectedContract = null
                }
            }
        }
    }
}
